import React from 'react';
import Navbar from '../components/Navbar';
import Breadcrumb from '../components/Breadcrumb';
import ContentSplitSections from '../components/ContentSplitSections';
import { Link } from 'react-router-dom';
import '../styles/hardscape.css';
import CTASection from '../components/CTASection';


// Section One: Enduring Hardscape Services data
const enduringHardscapeServices = [
  {
    title: "Paver Installations",
    text: `Precision Meets Durability\n\nFrom driveways to patios, our paver systems combine aesthetic precision with practical longevity. Our crews prepare every base with care to prevent settling, frost movement, and wear. The result: surfaces that stay smooth, strong, and timeless.\n\nApplications include:\n• Driveways and parking areas\n• Walkways and garden paths\n• Pool decks and gathering spaces\n• Permeable and decorative paver systems`,
    image: "/images/hardscape/HomePaverCover1.jpg",
    alt: "Professional paver installation",
    reverse: false
  },
  {
    title: "Retaining Walls & Structures",
    text: `Engineering with Artistry\n\nWe build walls that do more than retain — they define and connect spaces. Whether it's a terraced garden, a seat wall around a patio, or a structural hillside wall, each installation is engineered for integrity and built with visual harmony.\n\nWall Types:\n• Engineered retaining walls\n• Natural boulder or rock walls\n• Decorative seat and privacy walls\n• Terraced gardens and steps`,
    image: "/images/hardscape/retainingWall3.jpeg",
    alt: "Stone retaining wall construction",
    reverse: true
  },
  {
    title: "Natural Stone Masonry",
    text: `Timeless, Natural, Enduring\n\nOur masons hand-select every stone to complement your home and landscape. From flagstone patios to natural rock retainment walls, each element is crafted to age gracefully, reflecting the character of the Wood River Valley.\n\nPopular Applications:\n• Flagstone patios and walkways\n• Stone steps and garden borders\n• Natural rock retaining walls\n• Water feature surroundings`,
    image: "/images/hardscape/waterfall.jpg",
    alt: "Natural stone patio installation",
    reverse: false
  },
];

// Section Two: Outdoor Living Spaces data
const outdoorLivingSpaces = [
  {
    title: "Fire Features",
    text: `Gather Around the Glow\n\nA fire brings people together. From rustic stone pits to modern gas fireplaces, we create custom fire features that become the heart of your outdoor environment. Every installation is designed for safety, comfort, and connection.\n\nOptions include:\n• Natural stone fire pits\n• Gas or wood-burning fireplaces\n• Cooking and entertaining features\n• Integrated seating and surroundings`,
    image: "/images/fire/customPitNight.jpg",
    alt: "Custom fire pit installation",
    reverse: false
  },
  {
    title: "Outdoor Living",
    text: `Designed for Connection, Built for Every Season\n\nYour outdoor space should feel like an extension of your home — a place to gather, cook, or unwind beneath Idaho's open sky. We design and build complete outdoor living environments that balance comfort, beauty, and durability. Each space is customized to your lifestyle and crafted to perform through the Valley's changing seasons.\n\nCommon Features:\n• Outdoor kitchens and bar seating\n• Lounge areas and built-in seating walls\n• Dining patios and pergola structures\n• Integrated lighting and heating elements\n• Storage and weather-resistant finishes`,
    image: "/images/hardscape/homeHardscape1.jpg",
    alt: "Luxury outdoor kitchen design",
    reverse: true
  },
];

const Hardscape = () => {

  return (
    <div className="hardscape-page">
      <Navbar />
      <Breadcrumb />
      {/* Hero Section */}
      <section 
        className="hardscape-hero">
         <img
          src="/images/hardscape/hardscapeHero1.jpeg"
          alt="Beautiful Flower Garden" 
          className="hero-image"
          loading="eager"
          decoding="async"
        />
        <div className="hardscape-hero-content">
          <h1 className="hardscape-hero-title">Built to Last. Designed to Live In.</h1>
          <p className="hardscape-hero-subtitle">
            From patios and retaining walls to outdoor kitchens and fire features — we create spaces that bring beauty, function, and longevity to your property.
          </p>
          <div className="hero-buttons">
            <Link to="mailto:info@allseasons.info">
              <button
                className="btn-cta"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textTransform: "uppercase" }}
              >
                Request a Consultation
              </button>
            </Link>
            <Link to="/Gallery">
              <button
                className="btn-primary"
                style={{ textTransform: "uppercase", marginLeft: '1rem' }}
              >
                View Our Work
              </button>
            </Link>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="section bg-white">
        <div className="section-inner">
          <div className="intro-content">
            <h2 className="section-title text-center">Hardscapes That Define Your Outdoor Living</h2>
            <p className="intro-text">
              We design and build landscape features that enhance the beauty and the purpose of your property. Each project blends craftmanship and engineering to feature unique stones, pavers and structures designed to sustain Idaho's seasons.
            </p>
          </div>
        </div>
      </section>

      {/* Section One: Enduring Hardscape Services */}
      <section className="section bg-white section-divider-editorial">
        <div className="section-inner">
          <h2 className="section-title text-center">Enduring Hardscape Services</h2>
          <p className="section-subtitle text-center">We design and build landscape features that enhance the beauty and the purpose of your property. Each project blends craftmanship and engineering to feature unique stones, pavers and structures designed to sustain Idaho's seasons.</p>
        </div>
      </section>

      <ContentSplitSections sections={enduringHardscapeServices} />

      {/* Gallery CTA */}
      <section className="section bg-white">
        <div className="section-inner text-center">
          <Link to="/Gallery/hardscape" className="btn-primary">
            View Our Work
          </Link>
        </div>
      </section>

      {/* Section Two: Outdoor Living Spaces */}
      <section className="section bg-white section-divider-editorial">
        <div className="section-inner">
          <h2 className="section-title text-center">Outdoor Living Spaces</h2>
          <p className="section-subtitle text-center">Outdoor spaces should feel as inviting as the rooms inside your home. From fire pits and relaxation to kitchen spaces and hosting friends, we design and build spaces made to live in and to love, season after season.</p>
        </div>
      </section>

      <ContentSplitSections sections={outdoorLivingSpaces} />

      {/* Gallery CTA */}
      <section className="section bg-white">
        <div className="section-inner text-center">
          <Link to="/Gallery/hardscape" className="btn-primary">
            View Our Work
          </Link>
        </div>
      </section>

      {/* Section Three: Our Process */}
      <section className="section bg-white section-divider-editorial process-section">
        <div className="section-inner">
          <h2 className="section-title text-center">Our Process</h2>
        </div>
      </section>

      <section className="section bg-clean-snow process-section">
        <div className="section-inner">
          <div className="process-timeline">
            <div className="process-step">
              <div className="step-number">1</div>
              <h3>Design Consultation</h3>
              <p>We listen to your goals and assess your space.</p>
            </div>
            <div className="process-step">
              <div className="step-number">2</div>
              <h3>Custom Design</h3>
              <p>We craft detailed plans tailored to your property.</p>
            </div>
            <div className="process-step">
              <div className="step-number">3</div>
              <h3>Material Selection</h3>
              <p>Choose from premium materials that complement your home.</p>
            </div>
            <div className="process-step">
              <div className="step-number">4</div>
              <h3>Expert Installation</h3>
              <p>Every element is installed with precision and care.</p>
            </div>
            <div className="process-step">
              <div className="step-number">5</div>
              <h3>Finishing Touches</h3>
              <p>We complete your project with attention to every detail.</p>
            </div>
            <div className="process-step">
              <div className="step-number">6</div>
              <h3>Ongoing Maintenance</h3>
              <p>Custom seasonal care beyond installation to protect your investment.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <CTASection 
  title="READY TO ADD LASTING BEAUTY TO YOUR HARDSCAPE?"
  subtitle="LET OUR DESIGN TEAM HELP YOU CREATE OUTDOOR SPACES THAT YOU'LL ENJOY FOR A LIFETIME"
  galleryLink="/Gallery/hardscape"
  showEmergency={false}
/>
    </div>
  );
};

export default Hardscape;